import { boolean, mixed, number, object } from "yup";

export interface ClinicFeatureResource {
  feature: {
    id: FeatureId;
  };
  isEnabled: boolean;
  value: number;
}

export enum FeatureId {
  DIETITIANS = 1,
  PATIENTS = 2,
  PHOTO_DIARY_AI = 3,
  CHAT_PREMIUM = 4,
  PDF_PREMIUM = 5,
  NOTE_AI = 6,
}

export const clinicFeatureResourceSchema = object({
  feature: object({
    id: mixed<FeatureId>()
      .oneOf(Object.values(FeatureId) as FeatureId[])
      .required(),
  }).required(),
  isEnabled: boolean().required(),
  value: number().required(),
});
